import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button as MuiButton,
} from '@mui/material';
import React from 'react';

interface DeleteTemplateConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteTemplateConfirmationDialog: React.FC<
  DeleteTemplateConfirmationDialogProps
> = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>
        <FormattedAlias id='Confirm Delete' />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          <FormattedAlias id='Are you sure you want to delete this template? This action cannot be undone.' />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MuiButton onClick={onClose} color='primary'>
          <FormattedAlias id='Cancel' />
        </MuiButton>
        <MuiButton onClick={onConfirm} color='error' autoFocus>
          <FormattedAlias id='Delete' />
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTemplateConfirmationDialog;
